import { render, staticRenderFns } from "./Carnivores.vue?vue&type=template&id=a837dc04&"
import script from "./Carnivores.vue?vue&type=script&lang=js&"
export * from "./Carnivores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports